import React from 'react';
import { gql } from '@apollo/client';
import {
  DateField,
  FunctionField,
  NumberField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import EnumField from 'components/Enum/EnumField';
import LinkField from 'components/LinkField';
import MoneyField from 'components/MoneyField';
import { displayShiftTypes } from 'resources/professional_saas_details/utils';

const ProfessionalSaasDetailShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <LinkField source="professional_id" />
      <NumberField
        label="Max Weekly Hours"
        source="max_weekly_hours"
        options={{ maximumFractionDigits: 2 }}
      />
      <MoneyField label="Hourly Rate" source="hourly_rate_cents" />
      <FunctionField
        label="Shift Types"
        render={(record) => displayShiftTypes(record?.shift_types)}
      />
      <EnumField label="Employment Type" source="employment_type" />
      <DateField label="Offboarded At" source="offboarded_at" />
      <TextField label="Offboarded Reason" source="offboarded_reason" />
    </SimpleShowLayout>
  </Show>
);

ProfessionalSaasDetailShow.query = gql`
  query GET_ONE($id: Int!) {
    professionalSaasDetail(id: $id) {
      id
      max_weekly_hours
      hourly_rate_cents
      shift_types
      employment_type
      offboarded_at
      offboarded_reason
      professional_id
    }
  }
`;

export default ProfessionalSaasDetailShow;
